import CheckSignOff from '../../components/CheckSignOff';
import React from 'react';
import { HiChevronLeft } from 'react-icons/hi';
import { BiChevronRight, BiChevronDown } from 'react-icons/bi';
import { FiCalendar, FiClock } from 'react-icons/fi';
import { BsLightningCharge  } from 'react-icons/bs';

export default function PatCheckHeader() {
  return (
    <header className="w-full bg-white p-6 font-sans select-none">
      {/* Top Navigation Row */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-5">
        {/* Breadcrumb Navigation */}
        <nav className="flex items-center space-x-1 text-sm font-semibold text-blue-600">
          <HiChevronLeft className="w-5 h-5 cursor-pointer text-blue-700" />
          <span className="hover:underline cursor-pointer">Checks</span>
          <BiChevronRight className="w-5 h-5 text-gray-400 font-bold" />
          <span className="text-slate-600 font-bold text-xs tracking-tight">PAT Check (Monthly)</span>
        </nav>

        {/* Top Right Action Trigger (View History) */}
        <div className="flex items-center justify-end">
          <button className="flex items-center space-x-2 px-4 py-2 border border-gray-200 rounded-xl bg-white hover:bg-gray-50 transition text-xs font-bold text-slate-800 shadow-sm">
            <FiClock className="w-4 h-4 text-slate-800" />
            <span>View History</span>
          </button>
        </div>
      </div>

      {/* Main Bottom Details Content Row */}
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
        
        {/* Left Side Layout Grouping: Badge Icon, Title, and Subtitle */}
        <div className="flex items-start space-x-4 max-w-3xl">
          {/* Main PAT Lightning Shield Logo Block */}
          <div className="flex-shrink-0 w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center shadow-md shadow-blue-100">
            <BsLightningCharge  className="w-8 h-8 text-white" />
          </div>

          {/* Text Container Stack */}
          <div className="space-y-1 mt-0.5">
            <h1 className="text-2xl md:text-3xl font-extrabold text-blue-950 tracking-tight text-left">
              PAT Check (Monthly)
            </h1>
            <p className="text-slate-400 text-xs md:text-sm font-medium leading-relaxed text-left">
              Portable Appliance Testing check and verification.
            </p>
          </div>
        </div>

        {/* Right Action and Date Grid Settings */}
        <div className="flex flex-row lg:flex-col items-center lg:items-end gap-3 self-end lg:self-start flex-wrap">
          {/* Date Picker Selector Row */}
          <button className="flex items-center space-x-2 px-3 py-2 border border-gray-200 rounded-xl bg-white hover:bg-gray-50 transition text-xs font-bold text-slate-800 shadow-sm w-fit">
            <FiCalendar className="w-4 h-4 text-slate-800" />
            <span>18 Jul 2026</span>
            <BiChevronDown className="w-4 h-4 text-gray-400 ml-1" />
          </button>

          {/* Badge and Call-to-Action Parallel Bottom Alignment Row */}
          <div className="flex items-center space-x-3 w-full lg:w-auto justify-end">
            {/* Recurrence Badge Tag */}
            <span className="inline-flex items-center space-x-1.5 px-3 py-2 bg-blue-50/60 text-blue-700 rounded-xl text-xs font-bold border border-blue-100/40 h-[38px]">
              <FiCalendar className="w-3.5 h-3.5 text-blue-600" />
              <span>Monthly Check</span>
            </span>

            {/* Main Submit Layout Action Button */}
            <CheckSignOff slug="pat-check" label="Save & Complete" />
          </div>
        </div>

      </div>
    </header>
  );
}
